import "./Feedback.scss";
import { Feedback } from "@/components";
import { FeedBackProps } from "@anoki/fse-common";

type FeedbackSectionProps = {
  section: {
    feedback: FeedBackProps;
    sectionId?: string;
  };
};

export function FeedbackSection({
  section: { feedback, sectionId = "" },
}: FeedbackSectionProps) {
  return (
    <section className="container-feedback-bg" id={sectionId}>
      <div className={"content-container"}>
        <div className="container-feedback-section feedback-container section-padding d-flex justify-content-center align-items-center">
          {feedback && (
            <Feedback
              rating={feedback?.rating}
              questions={feedback?.questions ?? []}
              onSend={feedback?.onSend}
              question={feedback?.question}
              buttons={feedback?.buttons}
              successMessage={feedback?.successMessage}
              errorMessage={feedback?.errorMessage}
              loadingMessage={feedback?.loadingMessage}
              maxCharactersMessage={feedback?.maxCharactersMessage}
              isLoading={feedback?.isLoading}
              hasError={feedback?.hasError}
              openAnswerPlaceholder={feedback?.openAnswerPlaceholder}
            />
          )}
        </div>
      </div>
    </section>
  );
}
